import {
  Calendar,
  BookOpen,
  AlertCircle,
  FileSpreadsheet,
  CalendarDays,
  CalendarCheck2,
  Timer,
  LibraryBig,
  UserRoundCheck,
  Megaphone,
  FileText,
} from "lucide-react";

/**
 * Academics hub — derived from schoolNavData "ACADEMICS" category.
 *
 * schoolNavData mixes grouped items (with children) and flat single-link
 * items (Notice Board, Syllabus Templates) under one category.
 *
 * Both are normalized here into the same:
 *
 * {
 *   sectionTitle,
 *   sectionIcon,
 *   links: []
 * }
 *
 * shape so HubSection / HubGrid render either kind identically.
 *
 * Individual link icons are semantic Lucide icons. HubIcon handles the
 * Quiet Duotone styling centrally.
 */
export const hubAcademicsLinks = [
  {
    sectionTitle: "Academic Setup",
    sectionIcon: Calendar,

    links: [
      {
        label: "Academic Years",
        url: "/academic-years",
        desc: "Manage academic year sessions",
        module: "ACADEMIC_YEAR",
        permission: "ACADEMIC_YEAR_VIEW",
        icon: CalendarDays,
      },
      {
        label: "Academic Calendar",
        url: "/academic-calendar",
        desc: "Holidays, events & terms",
        module: "ACADEMIC_CALENDAR",
        permission: "ACADEMIC_CALENDAR_VIEW",
        icon: CalendarCheck2,
      },
      {
        label: "Timetable Manager",
        url: "/timetable",
        desc: "Class & section timetables",
        module: "TIMETABLE",
        permission: "TIMETABLE_VIEW",
        icon: Timer,
      },
    ],
  },

  {
    sectionTitle: "Subject Management",
    sectionIcon: BookOpen,

    links: [
      {
        label: "Subjects",
        url: "/subjects",
        desc: "Subject list & configuration",
        module: "SUBJECT_MANAGEMENT",
        permission: "SUBJECT_MANAGEMENT_VIEW",
        icon: LibraryBig,
      },
      {
        label: "Teacher Assignments",
        url: "/teacher-subjects",
        desc: "Map teachers to subjects",
        module: "SUBJECT_MANAGEMENT",

        // NOTE: no dedicated permission key was found for teacher-subjects
        // in App.js's /staff-panel routes (only /staff-panel/my-subjects,
        // ungated, was visible).
        //
        // Falling back to SUBJECT_MANAGEMENT_VIEW — confirm this is the
        // intended gate before shipping.
        permission: "SUBJECT_MANAGEMENT_VIEW",

        icon: UserRoundCheck,
      },
    ],
  },

  {
    // Flat item in schoolNavData (no children) — single-link section.
    sectionTitle: "Notice Board",
    sectionIcon: AlertCircle,

    links: [
      {
        label: "Notice Board",
        url: "/notices",
        desc: "School-wide announcements",
        module: "NOTICE_BOARD",
        permission: "NOTICE_VIEW",
        icon: Megaphone,
      },
    ],
  },

  {
    // Flat item in schoolNavData (no children) — single-link section.
    sectionTitle: "Syllabus",
    sectionIcon: FileSpreadsheet,

    links: [
      {
        label: "Syllabus Templates",
        url: "/syllabus",
        desc: "Templates, progress & overview",
        module: "SYLLABUS",
        permission: "SYLLABUS_VIEW",
        icon: FileText,
      },
    ],
  },
];

export default hubAcademicsLinks;